<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header" v-if="thai_student==1">
              <strong>แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต</strong>
            </div>
            <div slot="header" v-if="thai_student==0">
              <strong>Graduates’ Self-Assessment of Future Skills</strong>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK">
              <b-row>
                <b-col sm="1"></b-col>
                <b-col sm="11">
              {{ item.QUESTION_NAME }}
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"></b-col> <b-col sm="10">
              <li v-if="item.QUESTION_PK==209" v-for="(detail1, index) in detail1s">
                {{ detail1 }}
                <strong><font color="red" v-if="(index< (detail1s.length-1) )&& (thai_student==1)"> และ </font></strong>
                <strong><font color="red" v-if="(index< (detail1s.length-1) )&& (thai_student==0)"> and </font></strong>
              </li>
              <li v-if="item.QUESTION_PK==210" v-for="(detail2, index)  in detail2s">
                {{ detail2 }}
                <strong> <font color="red" v-if="(index< (detail2s.length-1) )&& (thai_student==1)"> และ </font></strong>
                <strong> <font color="red" v-if="(index< (detail2s.length-1) )&& (thai_student==0)"> and </font></strong>
              </li>
              <li v-if="item.QUESTION_PK==211" v-for="(detail3, index) in  detail3s">
                {{ detail3 }}
                <strong><font color="red" v-if="(index< (detail3s.length-1) )&& (thai_student==1)"> และ </font></strong>
                <strong><font color="red" v-if="(index< (detail3s.length-1) )&& (thai_student==0)"> and </font></strong>
              </li>
              </b-col>
              </b-row>
            </div>

            <div slot="footer" class="text-right">
              <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onNext">
                <i class="fa fa-arrow-circle-o-right"></i> Next
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <table align=center>
    </table>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateDetailpart10_2",
  data() {
    return {
      std_id: "",
      thai_student: "",
      items: [],
      ans: [],
      ans1: "",
      ans2: "",
      ans3: "",
      ans4: "",
      index:0,
      detail1s: [],
      detail2s: [],
      detail3s: [],
      detail4s: [],
      dangerModal: false,
      actionUpdate: true,
      actionUpdateRegis: true,
    };
  },

  methods: {
    getAns(studentid) {
      api
        .getAnsAllPart10(studentid)
        .then(res => {
          // var currentSt = res.data.data[0];
          // console.log("getAnsAllPart10==", res)
          this.ans = res.data.data[0];
          this.ans1 = parseInt(res.data.data[0].QN_209);
          this.getDetailAns(209, this.thai_student, this.ans1);
          this.ans2 = parseInt(res.data.data[0].QN_210);
          this.getDetailAns(210, this.thai_student, this.ans2);
          this.ans3 = parseInt(res.data.data[0].QN_211);
          this.getDetailAns(211, this.thai_student, this.ans3);

        })
        .catch(err => {
          // console.log(2);
          console.log("getAnsAllPart10==", err.toString());
        });
    },
    getDetailAns(qid, th, ans) {

      api
        .getAnsLoop(qid, th, ans)
        .then(res => {
          // console.log("getDetailAns==", res, res.data.data.length)
          var tempData = [];
          for (var i = 0; i < res.data.data.length; i++) {
              tempData.push(res.data.data[i].BYTEDES)
          }
          if (qid == 209) {
            this.detail1s = tempData;
          } else if (qid == 210) {
            this.detail2s = tempData;
          } else if (qid == 211) {
            this.detail3s = tempData;
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = false;
          // this.$router.push("login");
        });
    },
    getQuestion(thaistudent, start, finish) {
      api
        .getQuestionbetweenPart10(thaistudent, start, finish)
        .then(res => {
            this.items = res.data.data
          }
        )
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      this.getQuestion(10, this.sex, this.thai_student);
    },
    onNext() {
      this.$router.push("main");
    },
    onBack() {
      this.$router.push("main");
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
       //this.$router.push("/login");
    } else {
      // this.$router.push("/dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    var question = {}
    question.thaistudent = this.thai_student;
    question.start = 209;
    question.finish = 211;
    this.getQuestion(question);
    this.getAns(this.std_id)

    // this.actionUpdate = this.getCurrentStudent(this.std_id);
    // this.getCurrentAnsStudent(this.std_id);
    api.onSetHeader();
    //   this.getStudentQuestion();
    // this.getCurrentUserQuestion(this.std_id);

  }
};
</script>
<style>
</style>
